export const isEmpty = <O>(obj?: O) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const lens = (obj: any, path: string) =>
  path.split('.').reduce((a, v) => a[v], obj);
